import React from 'react'
import { HTMLOptions } from './ModalHost'

type Context = {
  isOpen: boolean
  handleModal: (modalContent: React.ReactNode, htmlOptions?: HTMLOptions) => void
  closeModal: () => void
  closeAllModals: () => void
}

const ModalContext = React.createContext<Context | undefined>(undefined)

export const useModal = () => {
  const context = React.useContext(ModalContext)
  if (context === undefined) throw new Error('useModal must be used within a ModalHost')
  return context
}

export { ModalContext }
